import React from "react";
import { Link } from "react-router-dom";
import { TABTestItem } from "../types/ab";

function OverflowOption(item: TABTestItem,
    icon: JSX.Element,
    label: string,
    linkFunction: (e: any, item: TABTestItem) => void, enabled: boolean) {
    return (
        <div className={`tw-py-1 tw-border ${enabled ? '' : 'tw-opacity-50 tw-pointer-events-none'}`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
            <Link to="#" onClick={(e) => enabled ? linkFunction(e, item) : e.preventDefault()} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-[#172b4d] ${enabled ? 'hover:tw-bg-[#F0F3FE]' : 'tw-cursor-default'}`} role="menuitem">
                <div className="tw-flex">
                    <div className="tw-mt-1">{icon}</div>
                    <span className="tw-ml-1">{label}</span>
                </div>
            </Link>
        </div>
    )
}

export default OverflowOption
